import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import { DATE_FORMAT } from '../../../constants/constants';
import Moment from 'moment';

const MAX_NUM_PROJECT_RESOURCES = 9;
const MAX_NUM_PROJECT_EPICDATES = 4;
export default class ProjectsForm extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	componentDidMount() {
		let projectEpicLabels = this.props.project.projectEpicLabels.slice();
		if (projectEpicLabels.length === 0) return;

		this.props.onFormChange('projectEpicLabels', projectEpicLabels);
	}

	onFormChange = (e) => {
		this.props.onFormChange(e.target.name, e.target.value);
	};

	onSelectBoxChange = (id, name) => {
		this.props.onFormChange(name, id);
	};

	onMultiSelectBoxChange = (csv, name) => {
		const newValue = csv ? csv.split(',') : [];
		this.props.onFormChange(name, newValue);
	};

	onToggleChange = (name, value) => {
		this.props.onFormChange(name, value);
	};

	onAddResource = () => {
		let resources = this.props.project.resources.slice();
		if (resources.length < MAX_NUM_PROJECT_RESOURCES) {
			resources.push({
				id: 0,
				name: '',
				url: '',
				isActive: true,
				ordinal: resources.length,
			});
		}
		this.props.onFormChange('resources', resources);
	};

	onResourceChange = (resource, index, field, e) => {
		let resources = this.props.project.resources.slice();
		resource[field] = e.target.value;
		resources.splice(index, 1, resource);
		this.props.onFormChange('resources', resources);
	};

	onAddEpicDate = () => {
		let projectEpicLabels = this.props.project.projectEpicLabels.slice();

		if (projectEpicLabels.length < MAX_NUM_PROJECT_EPICDATES) {
			projectEpicLabels.push({
				id: 0,
				name: '',
				isActive: true,
				ordinal: projectEpicLabels.length,
			});
		}
		this.props.onFormChange('projectEpicLabels', projectEpicLabels);
	};

	onEpicDateChange = (epicDate, index, field, e) => {
		let projectEpicLabels = this.props.project.projectEpicLabels.slice();
		epicDate[field] = e.target.value;
		projectEpicLabels.splice(index, 1, epicDate);
		this.props.onFormChange('projectEpicLabels', projectEpicLabels);
	};

	render() {
		return (
			<div>
				<form noValidate className={this.props.isFormValid ? '' : 'was-validated'} onSubmit={this.onSubmit}>
					<div className='col'>
						<InputText
							name='name'
							label='Project Name'
							placeholder='Project Name'
							type='text'
							value={this.props.project.name}
							onChange={this.onFormChange}
							isRequired={true}
							errorMessage='Project Name is required'
							maxLength={100}
						/>
						<InputText
							name='abbreviation'
							label='Abbreviation'
							placeholder='Abbreviation'
							type='text'
							value={this.props.project.abbreviation}
							onChange={this.onFormChange}
							isRequired={true}
							errorMessage='Abbreviation is required'
							maxLength={100}
						/>
						<InputText
							name='description'
							label='Description'
							placeholder='Description'
							type='text'
							value={this.props.project.description}
							onChange={this.onFormChange}
							isRequired={false}
							maxLength={600}
						/>
						<MultiSelectBox
							name='projectManagerId'
							label='Project Implementation Manager'
							idField='id'
							valueField='name'
							options={this.props.projectManagers}
							onChange={this.onSelectBoxChange}
							selectedValues={this.props.project.projectManagerId.toString()}
							isRequired={true}
							errorMessage='Project Manager is required'
							isMulti={false}
						/>
						<MultiSelectBox
							name='supportAgentId'
							label='Default Project Support Agent'
							idField='id'
							valueField='name'
							options={this.props.supportAgents}
							onChange={this.onSelectBoxChange}
							selectedValues={this.props.project.supportAgentId.toString()}
							isRequired={true}
							errorMessage='Support Agent is required'
							isMulti={false}
						/>

						{this.props.project.resources.map((resource, index) => {
							return (
								<div key={resource.ordinal}>
									<InputText
										name={`resourceName${index + 1}`}
										label={`Resource Name ${index + 1}`}
										placeholder={`Resource Name ${index + 1}`}
										type='text'
										value={resource.name}
										onChange={(e) => this.onResourceChange(resource, index, 'name', e)}
										isRequired={false}
										maxLength={50}
									/>
									<InputText
										name={`resourceUrl${index + 1}`}
										label={`Resource Url ${index + 1}`}
										placeholder={`Resource Url ${index + 1}`}
										type='url'
										value={resource.url}
										onChange={(e) => this.onResourceChange(resource, index, 'url', e)}
										isRequired={false}
										maxLength={500}
									/>
								</div>
							);
						})}
						{this.props.project.resources.length < MAX_NUM_PROJECT_RESOURCES && (
							<p>
								<a href='#' onClick={this.onAddResource}>
									Add Resource Link
								</a>
							</p>
						)}

						<InputText
							name='zeroDateName'
							label='Zero Date Name'
							placeholder='Zero Date Name'
							type='text'
							value={this.props.project.zeroDateName || 'Zero Date'}
							onChange={this.onFormChange}
							isRequired={true}
							errorMessage='Zero Date Name is required'
							maxLength={100}
						/>

						{this.props.IsProjectReferenceDatesActive &&
							this.props.project.projectEpicLabels.map((epicDate, index) => {
								return (
									<div key={epicDate.ordinal}>
										<InputText
											name={`epicDateName${index + 1}`}
											label={`Epic Name ${index + 1}`}
											placeholder={`Epic Name ${index + 1}`}
											type='text'
											value={epicDate.name}
											onChange={(e) => this.onEpicDateChange(epicDate, index, 'name', e)}
											isRequired={false}
											maxLength={50}
										/>
									</div>
								);
							})}
						{this.props.IsProjectReferenceDatesActive && this.props.project.projectEpicLabels.length < MAX_NUM_PROJECT_EPICDATES && (
							<p>
								<a href='#' onClick={this.onAddEpicDate}>
									Add Additional Epic for this Project
								</a>
							</p>
						)}

						<div className='task-detail-section location-task-tags-section'>
							<MultiSelectBox
								name='projectTagIds'
								options={this.props.projectTags}
								idField='id'
								valueField='name'
								selectedValues={this.props.project.projectTagIds.toString()}
								onChange={this.onMultiSelectBoxChange}
								isMulti={true}
								label='Tags'
							/>
						</div>

						{this.props.isProjectWaiversActive && (
							<Toggle
								name='canRequestProjectWaiver'
								text='Allow Locations to Request Project Waiver'
								checked={this.props.project.canRequestProjectWaiver}
								onChange={this.onToggleChange}
							/>
						)}

						<Toggle name='isActive' text='Active' checked={this.props.project.isActive} onChange={this.onToggleChange} />

						{this.props.project.isActive === false && this.props.project.dateInactive !== null && this.props.project.dateInactive && (
							<div className='alert alert-dark'>Inactive on {Moment.utc(this.props.project.dateInactive).format(DATE_FORMAT)}</div>
						)}

						{this.props.project.createdBy !== '' && this.props.project.createdDate !== null && (
							<div className='alert alert-dark'>
								Created by {this.props.project.createdBy} on {Moment.utc(this.props.project.createdDate).format(DATE_FORMAT)}
							</div>
						)}
					</div>
				</form>
			</div>
		);
	}
}

ProjectsForm.propTypes = {
	project: PropTypes.object.isRequired,
	projectManagers: PropTypes.array.isRequired,
	supportAgents: PropTypes.array.isRequired,
	onFormChange: PropTypes.func.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	onSubmit: PropTypes.func.isRequired,
	isProjectWaiversActive: PropTypes.bool.isRequired,
	IsProjectReferenceDatesActive: PropTypes.bool.isRequired,
	projectTags: PropTypes.array.isRequired,
};
